export class AppError extends Error {
  status: number | undefined
  code: string | number | undefined
  data: unknown

  constructor(message: string, status?: number, code?: string | number, data?: unknown) {
    super(message)
    this.name = 'AppError'
    this.status = status
    this.code = code
    this.data = data
  }
}

export function unwrapServerErrorMessage(message: string): string {
  let current = message.trim()
  for (let depth = 0; depth < 3; depth += 1) {
    const nested = nestedServerMessage(current)
    if (!nested || nested === current) return current
    current = nested
  }
  return current
}

function nestedServerMessage(message: string): string | undefined {
  const candidates = [message]
  const objectStart = message.indexOf('{')
  if (objectStart > 0) candidates.push(message.slice(objectStart))

  for (const candidate of candidates) {
    try {
      const parsed: unknown = JSON.parse(candidate)
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) continue
      const nested = (parsed as { message?: unknown }).message
      if (typeof nested === 'string' && nested.trim()) return nested.trim()
    } catch {
      // A normal business message is already the value that should be shown.
    }
  }
  return undefined
}
